export function frontLabel(labelsName, index) {
  return labelsName?.find(e => e.key === index)?.value ?? index;
}
